import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { deleteUser, getReferencesOfUser,getRoles,getUserById} from '../../utils/mainServices';
import { toggleConfirmationDialog, toggleLoader } from '../../shared/actions/setting';
import {useTranslation} from 'react-i18next';
import FeatherIcon from "feather-icons-react";
import { toast } from 'react-toastify';
import AddDropReferences from './addDropKit';
import { useParams } from "react-router-dom";
import UserForm from './userForm';
import Hierarchy from './hierarchyView';



const UserView = () => {
  const dispatch = useDispatch();
  const {t} = useTranslation();  
  const [referencesList, setReferencesList] = useState([]);
  const [deleteUserId, setDeleteUserId] = useState("");
  const [selectedUser, setSelectedUser] = useState([])
  const [isAddDropVisible, setIsAddDropVisible] = useState(false);
  const {id} = useParams()
  const [shouldFetchData, setShouldFetchData] = useState(false);
  const [isUserViewVisible, setIsUserViewVisible] = useState(false);
  const [roles, setRoles] = useState([])
  const [isHierarchyVisible, setIsHierarchyVisible] = useState(false);
  const [selectedReference, setSelectedReference] = useState(null);
  

  const confirmationDialog = useSelector(state => {
      return state.setting.confirmationDialog
    });

  useEffect(() => {
    const getUserDetails = async () => {
      try {
        dispatch(toggleLoader(true));
        const [userData, roleData] = await Promise.all([
          getUserById(id),
          getRoles()
        ]);
        const roleMap = new Map(roleData.content.map(role => [role.id, role.name]));

        const userWithRole = {
          ...userData.content,
          role: roleMap.get(userData.content.userRoleId) || 'N/A'
        };

        setSelectedUser(userWithRole);
        setRoles(roleData);

        try {
          const refs = await getReferencesOfUser(userWithRole.id);
          setReferencesList(refs?.content || []);
        } catch (err) {
          console.error('Error fetching user references:', err);
          setReferencesList([]);
        }
      } catch (error) {
        if (error.response && error.response.status === 422) {
          toast.warn(error.response.data.message);
        } else {
          toast.error("Something went wrong");
        }
      } finally {
        dispatch(toggleLoader(false));
      }
    }

    getUserDetails();
  }, [shouldFetchData, id])

//delete user
  useEffect(() => {
    if (!confirmationDialog || !confirmationDialog.onSuccess || !deleteUserId) {
      return;
    }
  
    const handleDelete = async () => {
      try {
        dispatch(toggleLoader(true));
        await deleteUser(deleteUserId);
        toast.success("User deleted succesfully");
      } catch (error) {
        if (error.response && error.response.status === 422) {
          toast.warn(error.response.data.message);
        } else {
          toast.error("Something went wrong");
        }
      } finally {
        dispatch(toggleLoader(false));
      }
    };
  
    handleDelete();
  }, [confirmationDialog, deleteUserId]);

  function handleDeleteUser(user) {
    dispatch(toggleConfirmationDialog({
      isVisible: true,
      confirmationHeading: t("confirmation_msg.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_USER_WITH_NAME", { name: (user?.lastName || user?.username || user?.email || "") }),
      confirmationDescription: t("confirmation_msg.THE_DELETE_ACTION_WILL_REMOVE_THE_USER_WITH_NAME", { name: (user?.lastName || user?.username || user?.email || "") })
    }));
    setDeleteUserId(user.id);
  }
  
// Fetching references moved inside getUserDetails to ensure ordering

  //add and drop
 function showAddDrop() {
  setIsAddDropVisible (true)
}

const hideAddDrop = (state) => {
  setIsAddDropVisible (false)
  if (state) {
    setShouldFetchData(prev => !prev);
  }
}

 //view user details
 function showUserVeiw() {
  setIsUserViewVisible (true)
 }

 const hideUserView = (state) => {
  setIsUserViewVisible(false)
  if (state) {
    setShouldFetchData(prev => !prev);
  }
 }

  function showHierarchy(item) {
    setSelectedReference(item);
    setIsHierarchyVisible(true);
  }

  const hideHierarchy = () => {
    setIsHierarchyVisible(false);
    setSelectedReference(null);
  }


  return (
     <div className={"half-list-container"}>
    <Container>
        <div className="single-card m-rl-m-8 p-a-16">
          <div className="sa-table-flex" style={{ marginBottom: 8 }}>
            <div className="xin-pull-left">
              <span className="sa-table-icon-flex sa-table-filter-position">
                <button
                  onClick={() => window.history.back()}
                  className={`sa-table-btn-secondary sa-table-float-left`}>
                  <FeatherIcon
                    icon={"chevron-left"}
                    className={"sa-table-icon-size"}/> {"  Back"}
                </button>
              </span>
            </div>
            <div className="xin-pull-right">
            <span className="sa-table-icon-flex sa-table-filter-position">
                <button
                  onClick={showUserVeiw}
                  className={`sa-table-btn-secondary sa-table-float-right`}>
                  <FeatherIcon
                    icon={"eye"} 
                    className={"sa-table-icon-size"}/> User Details
                </button>
              </span>
              <span className="sa-table-icon-flex sa-table-filter-position">
                <button
                  onClick={() => {
                    if (!(selectedUser.protect)) {
                      showAddDrop();
                    }
                  }}
                  className={`sa-table-btn-secondary sa-table-float-right ${selectedUser.protect ? 'disable-btn-secondary' : ''}`}>
                  <FeatherIcon
                    icon={"edit"} 
                    className={"sa-table-icon-size"}/> Add/Drop
                </button>
              </span>
              <span className="sa-table-icon-flex sa-table-filter-position">
                <button
                  onClick={() => {
                    if (!(selectedUser.protect)) {
                      handleDeleteUser(selectedUser);
                    }
                  }}
                  className={`sa-table-btn-secondary sa-table-float-right ${selectedUser.protect ? 'disable-btn-secondary' : ''}`}>                 
                  <FeatherIcon
                    icon={`trash-2`}
                    className={"sa-table-icon-size"}/> Delete
                </button>
              </span>
            </div>
          </div>
          <div className="sa-table-container xindicate-calc-height">
            <table className="table table-borderless">
              <thead>
                <tr>
                  <th className="sa-table-head-sticky">No</th>
                  <th className="sa-table-head-sticky">Name</th>
                </tr>
              </thead>
              <tbody>
                {referencesList.length > 0 ? (
                  referencesList.map((item, index) => (
                    <tr key={index}>
                      <td className="sa-table-data">{index + 1}</td>
                      <td className="sa-table-data">{item.name}</td>
                      <td className={'sa-table-item-align'}>
                        <div className='sa-table-item-flex'>
                          <div className="sa-table-actions sa-action-m" data-toggle="tooltip" title={t("button.VIEW")}>
                            <FeatherIcon
                              icon="eye"
                              className={`table-action`} 
                              onClick={() => showHierarchy(item)}
                              />
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center bg-white">
                      <div className={"empty-results mt-5"}>
                        <FeatherIcon icon="info"/>
                        <div className={"empty-results-text"}>{t("emptyMsg.NO_REFERENCES_AVAILABLE")}</div>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      {isAddDropVisible && <AddDropReferences selectedUserData={selectedUser} onClose={hideAddDrop} referencesList={referencesList}/>}
      {isUserViewVisible && <UserForm selectedUserData={selectedUser} onClose={hideUserView} formType={"view"} allRoles={roles}/>}
      {isHierarchyVisible && <Hierarchy selectedReference={selectedReference} userId={selectedUser?.id} onClose={hideHierarchy} />}
    </Container>
    </div>
  );
};

export default UserView;
